/**
 * ------------------------------------------------------------
 * Custom Our Values
 * IndianVastraa Premium Theme
 * ------------------------------------------------------------
 */

(() => {
  "use strict";

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const sections = document.querySelectorAll(".our-values-section");

  if (!sections.length) return;

  /*==========================================================
    Intersection Observer
  ==========================================================*/

  if ("IntersectionObserver" in window && !reduceMotion) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");

          const items = entry.target.querySelectorAll(".our-values__item");

          items.forEach((item, index) => {
            item.style.transitionDelay = `${index * 100}ms`;
            item.classList.add("is-visible");
          });

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.2,
      }
    );

    sections.forEach((section) => observer.observe(section));
  } else {
    sections.forEach((section) => {
      section.classList.add("is-visible");

      section
        .querySelectorAll(".our-values__item")
        .forEach((item) => item.classList.add("is-visible"));
    });
  }

  /*==========================================================
    Hover Animation
  ==========================================================*/

  if (!reduceMotion) {
    document.querySelectorAll(".our-values__item").forEach((card) => {
      card.addEventListener("mouseenter", () => {
        card.style.transform = "translateY(-8px)";
      });

      card.addEventListener("mouseleave", () => {
        card.style.transform = "";
      });
    });
  }
})();